import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdatePerson } from "~pages/Persons/types/upsertPerson.ts";
import type { PersonResponse } from "~types/person.ts";

export const useUpdatePerson = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<PersonResponse, Error, UpdatePerson>({
    mutationFn: async ({ personId, ...body }) =>
      await request<PersonResponse>(`${sport}/o/${organizationId}/persons/${personId}`, {
        method: "PUT",
        body,
      }),
    onSuccess: async (_response, { personId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["persons", sport, organizationId] }),
        queryClient.invalidateQueries({ queryKey: ["person", sport, organizationId, personId] }),
      ]);
    },
  });
};
